import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Global Members/HTML Elements/HTMLLinkElement";
import * as React from 'react';
export default {
  Content,
  React
};